import React, {useState} from 'react'
import {List, message, Modal, Radio, Result, Skeleton} from "antd"
import InfiniteScroll from "react-infinite-scroll-component"
import Search from "antd/es/input/Search"
import {ShopOutlined} from "@ant-design/icons"
import {bindShop, fetchShopList} from "../../../api/clubPlatform"
import {useClubPlatformContext} from "../store/useClubPlatformContext"


const ClubPlatformShopBind = ({platformId,merchantId}) => {
    const [hasMore, setHasMore] = useState(true)
    const [shopList, setShopList] = useState([])
    const [filterList, setFilterList] = useState([])
    const [selectedShop, setSelectedShop] = useState(null)
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isSelectLoading, setIsSelectLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [errMsg, setErrMsg] = useState('')


    const {getRelationStore} = useClubPlatformContext()

    const onSearch = (value) => {
        const filteredList = shopList.filter(item =>
            item.name.includes(value)
        )
        setFilterList(filteredList)
    }

    const handleRadioChange = async (e) => {
        setSelectedShop(e.target.value)
    }

    const handleClick = async () => {
        setIsShow(true)
        setIsLoading(true)
        await fetchShopList(platformId,merchantId).then(res => {
            if (res.status !== 1) {
                setIsError(true)
                setErrMsg(res.detail)
            }
            setShopList(res.data)
            setFilterList(res.data)
        }).catch((err) => {
            setIsError(true)
            setErrMsg(err.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleCancel = () => {
        setIsShow(false)
    }

    const handleOK = async () => {
        setIsSelectLoading(true)
        await bindShop(platformId, selectedShop).then(res => {
            if (res.status !== 1) {
                message.error(`绑定店铺失败：${res.detail}`)
                return
            }
            message.success("绑定店铺成功")
            setIsShow(false)
            getRelationStore()
        }).catch(err => {
            message.error(`绑定店铺失败：${err.message}`)
        }).finally(() => {
            setIsSelectLoading(false)
        })
    }


    return (
        <div>
            <div onClick={handleClick}>
                <ShopOutlined key="shop"/>
                <span style={{marginLeft: "5px"}}>选择店铺</span>
            </div>
            <Modal
                open={isShow}
                onCancel={handleCancel}
                confirmLoading={isSelectLoading}
                onOk={handleOK}
            >
                <div
                    style={{margin: "20px"}}
                >
                    {!isError ? <Skeleton loading={isLoading}>
                        <div>
                            <Search
                                placeholder="请输入店铺名称"
                                allowClear
                                enterButton="搜索"
                                size="large"
                                onSearch={onSearch}
                                onChange={(e) => onSearch(e.target.value)}
                            />
                        </div>
                        <div
                            id="scrollableDiv"
                            style={{
                                height: 300,
                                overflow: 'auto',
                                padding: '0 16px',
                                border: '1px solid rgba(140, 140, 140, 0.35)',
                                margin: '20px 0',
                            }}
                        >
                            <InfiniteScroll
                                next={null}
                                hasMore={hasMore}
                                loader={""}
                                dataLength={filterList.length}
                                scrollableTarget={"scrollableDiv"}
                            >
                                <List
                                    dataSource={filterList}
                                    renderItem={item => (
                                        <List.Item>
                                            <Radio
                                                value={item}
                                                checked={selectedShop === item}
                                                onChange={handleRadioChange}
                                            >
                                                {item.name}
                                            </Radio>
                                        </List.Item>
                                    )}
                                >
                                </List>
                            </InfiniteScroll>
                        </div>
                    </Skeleton> : <Result status={"error"} title={"获取店铺列表失败"} subTitle={errMsg}/>}
                </div>
            </Modal>
        </div>
    )
}

export default ClubPlatformShopBind


// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/component/ClubPlatformShopBind.js